export enum DNDType {
  CONCEPT_TREE_NODE = "CONCEPT_TREE_NODE",
  PREVIOUS_QUERY = "PREVIOUS_QUERY",
  PREVIOUS_SECONDARY_ID_QUERY = "PREVIOUS_SECONDARY_ID_QUERY",
  FORM_CONFIG = "FORM_CONFIG",
}
